<template>
  <v-container
    id="login"
    fluid
    tag="section"
  >
    <v-dialog
      v-model="carga"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="text-h4 font-weight-light white--text">
          INICIANDO SESIÓN
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      absolute
      touchless
      width="100%"
      :src="imgFondo"
      permanent
    >
      <v-card
        color="white"
        height="88%"
        width="95%"
        class="mx-auto"
      >
        <iframe
          width="100%"
          height="100%"
          src="https://lookerstudio.google.com/embed/reporting/3fd5a8f0-5bc2-40aa-9058-4c6a3275bb14/page/hNFAE"
          frameborder="0"
          style="border:0"
          allowfullscreen
        />
      </v-card>
      <v-row justify="center">
        <v-col
          cols="12"
          md="4"
        >
          <v-btn
            dark
            block
            color="success"
            @click="$router.push('/juzgados')"
          >
            <v-icon left>
              mdi-calendar-clock
            </v-icon>
            VERIFICAR HORARIOS Y DATOS DE JUZGADOS DE PAZ
          </v-btn>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
  export default {
    name: 'Login',
    components: {
    },

    data: () => ({
      desk: true,
      usuario: '',
      clave: '',
      carga: false,
      sedeCorteData: '',
      regla: [v => !!v || 'El campo es requerido'],
      imgFondo: '',
      imgLogo: '',
      error: false,
      textoError: '',
    }),
    created () {
      if (navigator.maxTouchPoints > 1) {
        this.desk = false
      }
      this.imgFondo = localStorage.getItem('imgFondo')
      this.imgLogo = localStorage.getItem('imgLogo')
    },
    mounted () {
      this.$store.commit('SET_VALOR', true)
    },
  }
</script>
